import { __awaiter } from "tslib";
import AjaxUtils from './ajaxUtils';
const fetchActiveUserIntegration = () => __awaiter(void 0, void 0, void 0, function* () {
    const userIntegrations = yield AjaxUtils.get('/api/v2/user-integrations?status=enabled&$eager=[integration, tokens]');
    // Only single user integration is active
    return userIntegrations[0];
});
const authenticateUserIntegration = (provider) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const authentication = yield AjaxUtils.get(`/v2/user-integrations-auth?integrationName=${provider}&platform=plugin&version=${WEB_PLUGIN_VERSION}`);
        return authentication.authUrl;
    }
    catch (e) {
        return undefined;
    }
});
const disconnectUserIntegration = (userIntegrationId) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        return AjaxUtils.delete(`/api/v2/user-integrations/${userIntegrationId}`);
    }
    catch (e) {
        return undefined;
    }
});
const fetchUserIntegrationsAnalytics = () => __awaiter(void 0, void 0, void 0, function* () {
    try {
        return AjaxUtils.get('/api/v2/user-integrations/analytics');
    }
    catch (e) {
        return undefined;
    }
});
export { authenticateUserIntegration, disconnectUserIntegration, fetchActiveUserIntegration, fetchUserIntegrationsAnalytics, };
